// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","pageContent":"_1o6x6","closeIcon":"_3cVWT"};